import { c as _c } from "react/compiler-runtime";
import { Dialog, Portal } from '@chakra-ui/react';
import { DialogCloseTrigger } from '@src/components/chakra-ui/dialog';
import { CrmRoot } from '@src/components/sco/Admin/AiCrm/ui/CrmSurface';
import React, { type ReactNode } from 'react';

/** The recipe's default top and bottom margin (spacing.16 on each side) that the frame has to leave. */
const FRAME_HEIGHT = 'calc(100dvh - 8rem)';

/**
 * The explainer and the member record share one frame: the full width of the window up to 1280px,
 * and as tall as the window leaves room for. `dvh`, not `vh`, so it does not clip behind an iOS
 * address bar or on a short window. The body scrolls. The portal keeps the dialog above the admin nav.
 *
 * The stronger backdrop is this dialog's own. The global dialog backdrop is not changed for it.
 */
export function CrmWideDialog(props) {
  const $ = _c(15);
  let t0;
  if ($[0] !== props) {
    t0 = t1 => {
      const {
        open
      } = t1;
      if (!open) {
        props.onClose();
      }
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dialog.Backdrop backdropFilter="blur(5px)" bg="blackAlpha.700" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props.title) {
    t2 = <Dialog.Header flexShrink={0} pr={12}><Dialog.Title>{props.title}</Dialog.Title></Dialog.Header>;
    $[3] = props.title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogCloseTrigger aria-label="Close" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.children) {
    t4 = <Dialog.Body flex="1" minH={0} overflowY="auto"><CrmRoot>{props.children}</CrmRoot></Dialog.Body>;
    $[6] = props.children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <Portal>{t1}<Dialog.Positioner><Dialog.Content colorPalette="gray" display="flex" flexDirection="column" h={FRAME_HEIGHT} maxH={FRAME_HEIGHT} maxW="1280px" overflow="hidden" w="100%">{t2}{t3}{t4}</Dialog.Content></Dialog.Positioner></Portal>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props.open || $[12] !== t0 || $[13] !== t5) {
    t6 = <Dialog.Root lazyMount={true} unmountOnExit={true} open={props.open} scrollBehavior="inside" onOpenChange={t0}>{t5}</Dialog.Root>;
    $[11] = props.open;
    $[12] = t0;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}